import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authed: localStorage.getItem("token") ? true : false,
  token: null,
  loginLoading: false,
  loginError: null,
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthed: (state, action) => {
      state.authed(action.payload);
    },
    loginStart: (state) => {
      state.loginLoading = true;
    },
    loginSuccess: (state, action) => {
      state.token = action.payload;
      state.loginLoading = false;
      state.loginError = null;
    },
    loginFail: (state, action) => {
      state.authed = false;
      state.token = null;
      state.loginLoading = false;
      state.loginError = action.payload;
    },
    loginReset: (state) => {
      state.token = null;
      state.loginLoading = false;
      state.loginError = null;
    },
  },
});

export const { setAuthed, loginStart, loginSuccess, loginFail, loginReset } =
  auth.actions;

export default auth.reducer;
